import React, { useEffect, useContext, useState } from 'react'
import {
  Form,
  Grid,
  Loader,
  Header,
  Icon,
  Radio,
  Dropdown,
  Button
} from 'semantic-ui-react'
import { AppContext } from './../../providers'
import { getClient } from './../../utils/functions'
import {
  Swatches
} from './../../components'
import { UnControlled as CodeMirror } from 'react-codemirror2'
import 'codemirror/mode/javascript/javascript'
import {
  saveToLocalStorage,
} from './../../utils/localStorage'

const tabOptions = [
  {
    key: '',
    text: '',
    value: '',
  },
  {
    key: 'rows',
    text: 'Rows',
    value: 'rows',
  },
  {
    key: 'content',
    text: 'Content',
    value: 'content',
  },
  {
    key: 'settings',
    text: 'Settings',
    value: 'settings',
  }
]

const cssOptions = [
  {
    key: '',
    text: '',
    value: '',
  },
  {
    key: 'dark',
    text: 'Dark Theme',
    value: 'https://bee-plugin-demos.getbee.io/themes/dark.css',
  },
  {
    key: 'eightbit',
    text: 'eightbit Theme',
    value: '/themes/eightbit.css',
  },
]

const backgroundOptions = [
  {
    key: '',
    text: '',
    value: '',
  },
  {
    key: '109',
    text: 'Oktoberfest',
    value: '109',
  },
  {
    key: '111',
    text: 'Earth Day',
    value: '111',
  }
]

const positionOptions= [
  {
    key: '',
    text: '',
    value: '',
  },
  {
    key: 'default',
    text: 'Default',
    value: 'default',
  },
  {
    key: 'classic-center',
    text: 'Classic Center',
    value: 'classic-center',
  },
  {
    key: 'classic-top-right',
    text: 'Classic Top Right',
    value: 'classic-top-right',
  },
  {
    key: 'classic-top-left',
    text: 'Classic Top Left',
    value: 'classic-top-left',
  },
  {
    key: 'classic-bottom-right',
    text: 'Classic Bottom Right',
    value: 'classic-bottom-right',
  },
  {
    key: 'classic-bottom-left',
    text: 'Classic Bottom Left',
    value: 'classic-bottom-left',
  },
  {
    key: 'drawer-left',
    text: 'Left Drawer/ Slide',
    value: 'drawer-left',
  },
  {
    key: 'drawer-right',
    text: 'Right Drawer/ Slide',
    value: 'drawer-right',
  },
  {
    key: 'bar-bottom',
    text: 'Bottom Bar',
    value: 'bar-bottom',
  },
  {
    key: 'bar-top',
    text: 'Top Bar',
    value: 'bar-top',
  }
]

const ManageSettings = (props) => {
  const { beeAPI } = useContext(AppContext)
  const { store, dispatch } = beeAPI
  const { config } = store

  const [json, setJSON] = useState(null)
  const [sideBarPosition, setSideBarPosition] = useState()

  const saveSettings = (merge) => {
    dispatch({
      payload: {
        config: {
          ...config,
          ...merge
        },
      }
    })
  }

  useEffect(() => {
    const deepClone = JSON.parse(JSON.stringify(config))
    delete deepClone.rowsConfiguration
    delete deepClone.mergeTags
    delete deepClone.specialLinks
    delete deepClone.mergeContents
    delete deepClone.rowDisplayConditions
    setJSON(deepClone)
    setSideBarPosition(config.sidebarPosition === 'left')
    config && config.container && saveToLocalStorage(config, 'config')
  }, [config])

  const options = {
    theme: 'material-palenight',
    mode: 'javascript',
    lineNumbers: true,
    lineWrapping: true,
    autoCloseBrackets: true,
    matchBrackets: true,
  }

  const onHandleCodeChange = (editor, data, value) => {
    dispatch(JSON.parse(value))
  }

  const handleTabChange = (e, { value }) => {
    const { defaultTab, ...rest } = config
    return (value)
      ? saveSettings({ defaultTab: value })
      : dispatch({
        payload: {
          config: {
            ...rest
          },
        }
      })
  }

  const handleCSSChange = (e, { value }) => {
    const { customCss, ...rest } = config
    return (value)
      ? saveSettings({ customCss: value })
      : dispatch({
        payload: {
          config: {
            ...rest
          },
        }
      })
  }

  const handlePositionChange = (e, { value }) => {
    const { position, ...rest } = config
    return (value)
      ? saveSettings({
        workspace: {
          ...config?.workspace,
          popup: {
            ...config?.workspace?.popup,
            layout: `${value}`,
          },
        },
      })
      : dispatch({
        payload: {
          config: {
            ...rest
          },
        }
      })
  }

  const handleBackgroundChange = (e, { value }) => {
    const { position, ...rest } = config

    const client = getClient()
    const baseURL = client.demoAPI

    return (value)
      ? saveSettings({
        workspace: {
          ...config?.workspace,
          popup: {
            ...config?.workspace?.popup,
            parentId: value,
            backgroundImage: `${baseURL}/getImage/${value}`,
            backgroundImageMobile: `${baseURL}/getImage/${value}`
          },
        },
      })
      : dispatch({
        payload: {
          config: {
            ...rest
          },
        }
      })
  }

  const handleToggleSidePanel = () => {
    const isLeft = (!sideBarPosition)
    setSideBarPosition(isLeft)
    saveSettings({
      sidebarPosition: (isLeft === true)
        ? 'left'
        : 'right'
    })
  }

  const onHandleAddColor = (color, event) => {
    const hex = color.hex
    if (hex) {
      const currentColors = config.defaultColors || []
      const mergedColors = currentColors.concat(hex)
      saveSettings({
        defaultColors: [...new Set(mergedColors)]
      })
    }
  }

  const onHandleRemoveColor = (color, event) => {
    const hex = color.hex
    if (hex) {
      const currentColors = config.defaultColors
      saveSettings({
        defaultColors: currentColors.filter(item => item !== hex)
      })
    }
  }

  const colors = (config && config.defaultColors)
    ? config.defaultColors
    : []

  const lastSaved = (localStorage.getItem('lastSaved'))
    ? new Date(localStorage.getItem('lastSaved'))
    : undefined

  return (
    (json && json.container)
      ? (
        <>
          <Header as='h2'>
            <Icon name='settings' />
            <Header.Content>
              Editor Settings
          <Header.Subheader>
                Change the JSON configuration of BEE Plugin.
          </Header.Subheader>
            </Header.Content>
          </Header>
          <Grid divided='vertically'>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Header as='h3'>
                  <Icon name='setting' />
                  <Header.Content>Featured v3 Settings</Header.Content>
                </Header>
                <Form>
                <Form.Field>
                    <label>Custom CSS:</label>
                    <Dropdown
                      placeholder=''
                      fluid
                      selection
                      options={cssOptions}
                      value={json.customCss || ''}
                      onChange={handleCSSChange}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>Default Tab:</label>
                    <Dropdown
                      placeholder=''
                      fluid
                      selection
                      options={tabOptions}
                      value={json.defaultTab || ''}
                      onChange={handleTabChange}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>Sidebar On Left:</label>
                    <Radio
                      defaultChecked={sideBarPosition}
                      onChange={handleToggleSidePanel}
                      toggle
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>Color Swatches:</label>
                    <Swatches
                      colors={colors}
                      onAddColor={onHandleAddColor}
                      onRemoveColor={onHandleRemoveColor}
                    />
                  </Form.Field>
                </Form>
                <Header as='h3'>
                  <Icon name='setting' />
                  <Header.Content>Popup Builder Settings</Header.Content>
                </Header>
                <Form>
                  <Form.Field>
                    <label>Position:</label>
                    <Dropdown
                      placeholder=''
                      fluid
                      selection
                      options={positionOptions}
                      value={json?.workspace?.popup?.layout || ''}
                      onChange={handlePositionChange}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>Background:</label>
                    <Dropdown
                      placeholder=''
                      fluid
                      selection
                      options={backgroundOptions}
                      value={json?.workspace?.popup?.parentId || ''}
                      onChange={handleBackgroundChange}
                    />
                  </Form.Field>
                </Form>
              </Grid.Column>
              <Grid.Column>
                <Header as='h3'>
                  <Icon name='edit outline' />
                  <Header.Content>Configuration Editor</Header.Content>
                </Header>
                <CodeMirror
                  value={JSON.stringify(json, null, 2)}
                  onChange={onHandleCodeChange}
                  options={options}
                />
                {
                  (lastSaved)
                    ? (
                      <>
                        <Button
                          circular
                          icon='clock outline'
                          style={{ marginTop: '10px' }}
                        />
                        <span className="lastsaved">Last saved -
                        {
                          lastSaved && lastSaved.toLocaleString('en-US', {
                            timeZone: 'UTC'
                          })
                        }</span>
                      </>
                    )
                    : (null)
                }
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </>
      )
      : (<div style={{ padding: '5em 0' }}><Loader active inline='centered' style={{ padding: '3em 0' }}>Loading</Loader></div>)
  )
}

export default ManageSettings
